import {
  CreateOnboardingRequestDto,
  OnboardingTasksResponseDto,
  OnboardingTaskUpdateRequestDto,
} from '@tiendanube/common';
import axios from 'App/axios';
import {
  DASHBOARD_ONBOARDING_TASK_MELI_SYNC_URL,
  DASHBOARD_ONBOARDING_TASK_PAYMENT_METHODS_URL,
  DASHBOARD_ONBOARDING_TASK_SETUP_LAYOUT_URL,
  DASHBOARD_ONBOARDING_TASK_SHIPPING_NATIVE_URL,
  DASHBOARD_ONBOARDING_TASK_TESTING_SALE_URL,
  DASHBOARD_ONBOARDING_TASKS_URL,
  DASHBOARD_ONBOARDINGS_URL,
} from '../urls';

export async function getOnboardingTasks(
  isMobile = false,
): Promise<OnboardingTasksResponseDto> {
  const { data } = await axios.get<OnboardingTasksResponseDto>(
    DASHBOARD_ONBOARDING_TASKS_URL + '?isMobile=' + isMobile,
  );
  return data;
}

export async function updateOnboardingTaskSetupPayments() {
  await axios.post(DASHBOARD_ONBOARDING_TASK_PAYMENT_METHODS_URL);
}

export async function updateOnboardingTaskSetupShippingNative() {
  await axios.post(DASHBOARD_ONBOARDING_TASK_SHIPPING_NATIVE_URL);
}

export async function updateOnboardingTaskSetupMeliSync() {
  await axios.post(DASHBOARD_ONBOARDING_TASK_MELI_SYNC_URL);
}

export async function updateOnboardingTaskSetupTestingSale() {
  await axios.post(DASHBOARD_ONBOARDING_TASK_TESTING_SALE_URL);
}

export async function updateOnboardingTaskSetupLayout() {
  await axios.post(DASHBOARD_ONBOARDING_TASK_SETUP_LAYOUT_URL);
}

export async function updateOnboardingTaskStatus(
  payload: OnboardingTaskUpdateRequestDto,
) {
  await axios.patch(DASHBOARD_ONBOARDING_TASKS_URL, payload);
}

export async function createOnboarding(
  payload: CreateOnboardingRequestDto,
): Promise<OnboardingTasksResponseDto> {
  const { data } = await axios.post<OnboardingTasksResponseDto>(
    DASHBOARD_ONBOARDINGS_URL,
    payload,
  );
  return data;
}
